import { post } from './axios.service';
import type {
    TermsAsset,
    CoverageTextItemRequest,
    CoverageTextItem
} from '../recoil/types/hippoTypes';
import type { IConfigProps } from '../context/ConfigContext';

async function loadTerms(
    topConfigContext: IConfigProps | undefined,
    termIds: string[]
): Promise<TermsAsset[]> {
    return await post<TermsAsset[]>(
        `${topConfigContext?.endpointConfig?.apiHippoHost ?? ''}/rest/terms/`,
        termIds
    );
}

async function loadCoverages(
    topConfigContext: IConfigProps | undefined,
    coverageItems: CoverageTextItemRequest[]
): Promise<CoverageTextItem[]> {
    return await post<CoverageTextItem[]>(
        `${topConfigContext?.endpointConfig?.apiHippoHost ?? ''}/rest/coverage/`,
        coverageItems
    );
}

export { loadTerms, loadCoverages };
